<template>
    <section class="g-wrapper">
        <header-com />
        <div style="width:100%;height:50px"></div>

        <div class="serviceContent">
          <h1 style="font-weight:600;text-align:center">《改样服务协议》</h1>
          <br>
          <h3 class="serviceh3">
            &#x3000;&#x3000;尊敬的用户，欢迎您接受由包拯工作室为您提供的皮包改样服务。您在接受我们的服务之前，请务必仔细阅读本用户协议。<br>
            &#x3000;&#x3000;点击“同意”按钮，即表示您已阅读并同意本协议下的全部条款，包括包拯工作室对服务条款做的任何更改。您一旦接受包拯工作室的改样服务，即视为您已充分了解并完全同意本服务条款的所有内容。
          </h3>
          <br>
          <h3 class="serviceh3" style="font-weight:600">&#x3000;&#x3000;第一条 服务内容</h3>
          <h3 class="serviceh3">
            &#x3000;&#x3000;改样服务是指有私有物品改样需求的个人消费者，基于自身使用的目的，委托包拯工作室将其拥有所有权的私有物品改造成指定样式的个性化定制服务。您需要了解并接受以下服务内容：<br>
            &#x3000;&#x3000;1.原则上，包拯工作室只为个人消费者提供改样服务，不为任何组织提供本服务。<br>
            &#x3000;&#x3000;2.改样后的物品须用于私人日常使用，而不能用于商业用途盈利。<br>
            &#x3000;&#x3000;3.改样服务内容仅限于用户提供的私有物品的手工改样以及破损部位的修复（如有必要），不包括任何商品的制造或销售，也不包括鉴定、验真等附属内容。<br>
            &#x3000;&#x3000;若您不是个人消费者，或您的行为代表了任何组织的意志，或您企图将改样后的物品用于商业或非私人用途，请勿接受本协议。
          </h3>
          <br>
          <h3 class="serviceh3" style="font-weight:600">&#x3000;&#x3000;第二条 权利义务</h3>
          <h3 class="serviceh3">
            &#x3000;&#x3000;1.用户对需改样物品应拥有合法权利，委托改样行为不会侵犯任何第三人的合法权益。<br>
            &#x3000;&#x3000;2.用户委托的内容不应侵犯任何第三人的合法权益。若涉嫌侵权，包拯工作室有权拒绝接受该委托内容。<br>
            &#x3000;&#x3000;3.用户保证所提供的物品信息真实、准确、完整，如有变更应及时更新。<br>
            &#x3000;&#x3000;4.用户应对其指定的改样款式负责。因改样款式引发的一切纠纷均由用户自行负责，包拯工作室不承担任何法律或连带责任。<br>
            &#x3000;&#x3000;5.用户对改样后的物品享有全部权益并对其个人的使用行为承担全部法律责任。因用户违反相关法律法规引发的一切纠纷均由用户自行负责，包拯工作室不承担任何法律或连带责任。<br>
            &#x3000;&#x3000;6.包拯工作室可以根据服务内容向用户收取相应的服务费。<br>
            &#x3000;&#x3000;7.包拯工作室保证服务质量，严格按照用户要求进行改样服务，在改样、修复过程中使用的原料、工艺等符合相关法律法规的规定。
          </h3>
          <br>
          <h3 class="serviceh3" style="font-weight:600">&#x3000;&#x3000;第三条 保护知识产权的特别约定</h3>
          <h3 class="serviceh3">
            &#x3000;&#x3000;为保护第三方的商标、专利权等知识产权，禁止用户将改样后的物品以正品的名义或以可能引起与正品混淆误认的方式向第三人宣传销售。
          </h3>

          <br>
          <h3 class="serviceh3" style="font-weight:600">&#x3000;&#x3000;第四条 不可抗力及免责</h3>
          <h3 class="serviceh3">
            &#x3000;&#x3000;您理解并同意，在使用本服务的过程中，可能会遇到不可抗力等风险因素，使本服务受到影响。不可抗力是指不能预见、不能克服并不能避免且对一方或双方造成重大影响的客观事件，包括但不限于罢工，暴乱，火灾，洪水，风暴，爆炸，战争而造成的不能服务或延迟服务承担责任等。出现上述情况时，我们将努力在第一时间与相关单位配合，争取及时进行处理，但是由此给您造成的损失，我们在法律允许的范围内免责。
          </h3>
          
          <br>
          <h3 class="serviceh3" style="font-weight:600">&#x3000;&#x3000;第五条 违约责任</h3>
          <h3 class="serviceh3">
            &#x3000;&#x3000;若用户违反上述约定给包拯工作室或者第三人的合法权益造成损害，应承担相应的赔偿责任。<br>
            &#x3000;&#x3000;若用户因违反上述约定侵犯第三人的知识产权，导致包拯工作室向第三人赔偿或受到执法机构处罚，用户应承担连带责任并赔偿包拯工作室因此遭受的相关损失。
          </h3>

          <br>
          <h3 class="serviceh3" style="font-weight:600">&#x3000;&#x3000;第六条 服务的变更、中断或终止</h3>
          <h3 class="serviceh3">
            &#x3000;&#x3000;如因政策、法律或包拯业务的调整而需要暂停或变更改样服务内容、服务价格、用户协议等条款，包拯工作室将尽可能通过官方渠道或其他途径向用户公告或通知。<br>
            &#x3000;&#x3000;如发现下列任何一种情况，对此产生的任何争议或纠纷，包拯工作室不承担任何责任，且有权单方面中断或终止服务：<br>
            &#x3000;&#x3000;1.用户并非个人消费者的；<br>
            &#x3000;&#x3000;2.用户拟将改样后的物品用于商业用途盈利的；<br>
            &#x3000;&#x3000;3.用户违反相关约定侵犯第三人知识产权或相关权益的。<br>
            &#x3000;&#x3000;4.用户商品来源存在违法行为，如盗窃、走私、非法买卖、侵犯他人合法权益等；<br>
            &#x3000;&#x3000;5.用户商品来源存在不明确或虚假的情况，可能存在使用上的风险或法律风险；<br>
            &#x3000;&#x3000;6.用户商品来源不合法或存在问题导致在使用或销售过程中被相关机构处罚或追究法律责任。
          </h3>

          <br>
          <h3 class="serviceh3" style="font-weight:600">&#x3000;&#x3000;第七条 服务条款的完善和修改</h3>
          <h3 class="serviceh3">
            &#x3000;&#x3000;包拯工作室有权根据自身业务的发展和中华人民共和国有关政策、法律法规的变化，不时地完善和修改包拯工作室的服务条款。用户在接受包拯工作室改样服务时应该仔细阅读和重新确认。当发生有关争议时，将以最新的服务条款为准。
          </h3>

        </div>

    </section>
</template>

<script>
	export default {
		name: "agreement",
        data() {
		    return {}
        },
        created() {
        }
	}
</script>


<style scoped lang="scss">
    .serviceContent{
    width: 100%;
    padding: 40px;
    box-sizing: border-box;
    .serviceh3{
      line-height: 56px;
    }
  }
</style>
